import React from "react";
import { Assets } from "utils/imports.utils";
import './loader.ui.scss';

const Loader = (props) => {
  // Reference

  // Redux

  // State

  //Hooks

  // Network req

  //Logic

  return (
    <div className="loader_wrapper" style={{width:props.width, height:props.height }}>
      <img src={props.icon || Assets.logo} width={"100%"} height={"100%"} />
    </div>
  );
};

export default Loader;
